<template>
  <NoteSection
    label="Mental Status"
    required
    :highlight-required="isSectionIncomplete"
    :form-validated="formValidated"
  >
    <auto-complete-box
      v-model="mental_status"
      :items="mentalStatuses"
      label="Mental Status"
      class="col-sm-12"
      required
    >
    </auto-complete-box>
  </NoteSection>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    value: {
      type: String,
      default: null,
    },
    formValidated: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mental_status: this.value,
    }
  },
  computed: {
    ...mapGetters('encounters', ['mentalStatuses']),

    // Checks if mental_status selection is missing
    isSectionIncomplete() {
      return !this.mental_status
    },
  },
  watch: {
    mental_status() {
      this.$emit('input', this.mental_status)
    },
  },
  methods: {
  },
}
</script>
